import { useMemo, ButtonHTMLAttributes } from "react";

export type IButton = {
  variant?: "success" | "info" | "none";
  onClick?: () => void;
  children?: React.ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

// bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded

export const Button = (props: IButton) => {
  const { variant = "none", children, className, onClick } = props;

  const Render = useMemo(() => {
    let classNameTags = `font-bold py-2 px-4 rounded-[24px] height-[24px] text-[16px] ${className}`;

    switch (variant) {
      case "success":
        classNameTags = classNameTags.concat(
          " ",
          `text-white bg-green-500 hover:bg-green-700`
        );
        break;
      case "info":
        classNameTags = classNameTags.concat(
          " ",
          `text-[#005339] bg-[#EEF9F9]`
        );
        break;
      case "none":
        classNameTags = classNameTags.concat(" ", `text-cyan-500`);
        break;
      default:
        break;
    }

    return (
      <button
        type="button"
        className={classNameTags}
        onClick={() => {
          onClick?.();
        }}>
        {children}
      </button>
    );
  }, [props]);

  return Render;
};
